import React from "react";
import DashboardRegisterTable from "./dashboardRegisterTable";

const Dashboard = () => {
  return (
    <div className="page-top-div">
      <DashboardRegisterTable />
    </div>
  );
};

export default Dashboard;
